import React from 'react';
import { Breakpoint, Stack, Text } from '@moda/om';
import { OrderItem } from '../../../hooks/useOrder';
import { OrderDetailsShippingStatus } from '../../OrderDetailsMain/OrderDetailsItemsSections/OrderDetailsShippingStatus';
import { OrderItemDetailsReturnPolicyMessage } from './OrderItemDetailsReturnPolicyMessage';

interface Props {
  item: OrderItem;
  showExtraDetails: boolean;
}

export const OrderItemDetails: React.FC<Props> = ({
  item: {
    attributes: {
      designerName,
      details: { name },
      color,
      size,
      quantity,
      shippingStatus,
      customization,
      isReturnable,
      giftEligibility,
      excessShipping,
      excludedFromRewards,
      returnPolicy,
      promotionApplicableMessage
    }
  },
  showExtraDetails
}) => (
  <Stack space={3}>
    <Stack space={0}>
      <Text treatment="bold1">{designerName}</Text>
      <Text>{name}</Text>
    </Stack>

    <Breakpoint gt="sm">
      <Stack space={3} direction="horizontal">
        <Stack space={1} direction="horizontal">
          <Text color="cement">Color:</Text>
          <Text>{color}</Text>
        </Stack>

        <Stack space={1} direction="horizontal">
          <Text color="cement">Size:&nbsp;</Text>
          <Text>{size}</Text>
        </Stack>

        <Stack space={1} direction="horizontal">
          <Text color="cement">Quantity:&nbsp;</Text>
          <Text>{quantity}</Text>
        </Stack>
      </Stack>
    </Breakpoint>

    <Breakpoint lt="sm">
      <Stack space={1}>
        <Stack space={1} direction="horizontal">
          <Text color="cement">Color:</Text>
          <Text>{color}</Text>
        </Stack>
        <Stack space={1} direction="horizontal">
          <Text color="cement">Size:&nbsp;</Text>
          <Text>{size}</Text>
        </Stack>
        <Stack space={1} direction="horizontal">
          <Text color="cement">Quantity:&nbsp;</Text>
          <Text>{quantity}</Text>
        </Stack>
      </Stack>
    </Breakpoint>

    {showExtraDetails && (
      <>
        {excessShipping && <Text>{excessShipping}</Text>}

        <OrderItemDetailsReturnPolicyMessage
          returnPolicy={returnPolicy}
          isReturnable={isReturnable}
          promoCodeApplied={!!promotionApplicableMessage}
        />

        <OrderDetailsShippingStatus shippingStatus={shippingStatus} />

        {giftEligibility && <Text>{giftEligibility}</Text>}

        {promotionApplicableMessage && <Text>{promotionApplicableMessage}</Text>}

        {excludedFromRewards && <Text>{excludedFromRewards}</Text>}

        {customization && <Text>{customization}</Text>}
      </>
    )}
  </Stack>
);
